import React, { useEffect, useRef } from "react";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";
import { updateCookie } from "../../store";
import { useThunk } from "../../hooks/useThunk";

const CookieBanner = () => {
  const initialized = useRef(false);
  const observerRef = useRef(null);

  const [doUpdateCookie] = useThunk(updateCookie);


  useEffect(() => {
    if (initialized.current) return; // avoid double init in React StrictMode
    initialized.current = true;

    const applyConsent = () => {
      if (CookieConsent.acceptedCategory("analytics")) {
        console.log("analytics ON");
      } else {
        console.log("analytics OFF");
      }
    };

    const logConsent = async () => {
      const cookie = CookieConsent.getCookie();
      const preferences = CookieConsent.getUserPreferences();

      const userConsent = {
          consentId: cookie.consentId,
          acceptType: preferences.acceptType,
          acceptedCategories: preferences.acceptedCategories,
          rejectedCategories: preferences.rejectedCategories
      };

      const result = await doUpdateCookie(userConsent);
      console.log(result);
    }

    CookieConsent.run({
      guiOptions: {
        consentModal: { layout: "bar", position: "bottom center", flipButtons: false, equalWeightButtons: false },
        preferencesModal: { layout: "bar", flipButtons: false, equalWeightButtons: true },
      },
      categories: {
        necessary: { enabled: true, readOnly: true },
        analytics: {},
        marketing: {},
      },
      language: {
        default: "en",
        translations: {
          en: {
            consentModal: {
              title: "We value your privacy",
              description:
                "We use cookies to improve your browsing experience, analyze how our site is used, and deliver personalized content and services. Some cookies are essential for the website to function, while others help us enhance performance and tailor recommendations.",
              acceptAllBtn: "Accept all",
              showPreferencesBtn: "Manage preferences",
            },
            preferencesModal: {
              title: "Manage preferences",
              acceptAllBtn: "Accept all",
              acceptNecessaryBtn: "Reject all",
              savePreferencesBtn: "Save",
              closeIconLabel: "Close modal",
              sections: [
                { description: "In our Order Management System, we use cookies to ensure smooth operations, improve efficiency, and provide you with a better user experience. These cookies help us remember your account preferences, securely process orders, analyze system performance, and personalize features based on your role (e.g., admin or client). You can choose which types of cookies you want to allow. Please note that disabling certain cookies may limit system functionality, such as order tracking, dashboard analytics, or personalized recommendations." },
                { title: "Essential Cookies", linkedCategory: "necessary", description: "These cookies are essential..." },
                { title: "Analytics Cookies", linkedCategory: "analytics", description: "These cookies help us improve..." },
                { title: "Marketing Cookies", linkedCategory: "marketing", description: "Used for personalized content..." },
              ],
            },
          },
        },
      },
      onConsent: () => {applyConsent()},
      onFirstConsent: () => {logConsent()},
      onChange: () => {applyConsent(); logConsent()},
    });

    // --- robust footer link injection ---
    const addPrivacyLink = () => {
      const footer = document.querySelector("#cc-main .pm__footer");
      if (!footer) return;
      // If the next sibling is already our link, skip
      if (footer.nextElementSibling?.classList?.contains("privacy-link")) return;

      const link = document.createElement("a");
      link.href = "/privacy-policy";
      link.target = "_blank";
      link.rel = "noopener";
      link.className = "privacy-link";
      link.textContent = "Privacy Policy";
      link.style.cssText = `
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        margin: 6px 0 10px 0 !important;
        text-align: center !important;
        font-size: 14px !important;
        color: #bfc8d2 !important;
        text-decoration: underline !important;
      `;
      footer.insertAdjacentElement("afterend", link);
    };

    // Observe #cc-main for modal (re)builds
    const root = document.querySelector("#cc-main") || document.body;
    observerRef.current = new MutationObserver(() => addPrivacyLink());
    observerRef.current.observe(root, { childList: true, subtree: true });

    // Try once now (in case modal already open)
    addPrivacyLink();

    return () => observerRef.current?.disconnect();
  }, []);

  return null;
};

export default CookieBanner;
